const apiUrl = process.env.REACT_APP_API_URL;
export const GetComandaId = async ( page : string, id : string) => {
    try {
        const response = await fetch(`${apiUrl}:8072/comandaes/${id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            }
        });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
